import { Heading } from '@chakra-ui/react';
import CustomTabs from '@Modules/core/components/customTab/CustomTabs';
import DetectorsFormHandler from '@Modules/terminalManagementSystem/gabManagement/containers/formHandlers/terminal/terminal/detector/DetectorsFormHandler';
import HardwardConfigurationFormHandler from '@Modules/terminalManagementSystem/gabManagement/containers/formHandlers/terminal/terminal/hardwareConfiguration/HardwardConfigurationFormHandler';
import HardwardConfiguration2FormHandler from '@Modules/terminalManagementSystem/gabManagement/containers/formHandlers/terminal/terminal/hardwareConfiguration2/HardwardConfiguration2FormHandler';
import IndentificationFormHandler from '@Modules/terminalManagementSystem/gabManagement/containers/formHandlers/terminal/terminal/identification/IndentificationFormHandler';
import KeysFormHandler from '@Modules/terminalManagementSystem/gabManagement/containers/formHandlers/terminal/terminal/keys/KeysFormHandler';
import PrintersFormHandler from '@Modules/terminalManagementSystem/gabManagement/containers/formHandlers/terminal/terminal/printers/PrintersFormHandler';
import TerminalFormHandler from '@Modules/terminalManagementSystem/gabManagement/containers/formHandlers/terminal/terminal/TerminalFormHandler';
import DistributionModuleMixedHandler from '@Modules/terminalManagementSystem/gabManagement/containers/mixedHandlers/terminal/distributionModule/DistributionModuleMixedHandler';
import PartsDistributorMixedHandler from '@Modules/terminalManagementSystem/gabManagement/containers/mixedHandlers/terminal/partsDistributor/PartsDistributorMixedHandler';

import React from 'react';

const tabHeaders = ['Identification', 'Module de Distribution', 'Imprimantes', 'Distributeur de Pièces', 'Detecteurs', 'Configuration Matériel', 'Configuration Matériel ...', 'Clés'];

const SalesPointPage = () => {
  const tabContents = React.useMemo(
    () => [<IndentificationFormHandler />, <DistributionModuleMixedHandler />, <PrintersFormHandler />, <PartsDistributorMixedHandler />, <DetectorsFormHandler />, <HardwardConfigurationFormHandler />, <HardwardConfiguration2FormHandler />, <KeysFormHandler />,],
    []
  );
  return (
    <>
      <Heading size="md" my={'2rem'}>
        Terminal
      </Heading>
      <TerminalFormHandler />
      <CustomTabs tabHeaders={tabHeaders} tabContents={tabContents} isLazy />
    </>
  );
};

export default SalesPointPage;
